import { styled } from 'styled-components'

import { color, font } from '~/styles/utils'

export const Amount = styled.div<{
  $bold?: boolean
}>`
  ${({ $bold }) => $bold && font('bold')};
`

export const NormalLine = styled.div`
  padding: 0 0 12px 0;
  ${font('base')};
  font-size: 16px;
  line-height: 17px;
  display: flex;
  justify-content: space-between;
`

export const DiscountLine = styled(NormalLine)`
  color: ${color('blueCreek')};
  text-transform: capitalize;
`
